import React from "react";
import { Phone } from "lucide-react";
import { RESTAURANT } from "@/data/catalog";

/**
 * Bouton flottant mobile — visible uniquement sur petits écrans.
 * But : maximiser l'appel téléphonique. Aucune logique de commande.
 */
export const CallFab = () => (
  <a
    href={RESTAURANT.phoneTel}
    aria-label={`Appeler ${RESTAURANT.name} au ${RESTAURANT.phoneDisplay}`}
    data-testid="call-fab"
    className="md:hidden fixed bottom-4 right-4 z-40 inline-flex items-center gap-2 rounded-full bg-[#FF9500] px-4 py-3 text-sm font-street tracking-wider text-black shadow-[0_6px_20px_rgba(255,149,0,0.45),0_4px_0_#7a4900] active:translate-y-0.5 active:shadow-[0_4px_15px_rgba(255,149,0,0.45),0_2px_0_#7a4900] transition-all"
  >
    <Phone size={16} strokeWidth={2.6} />
    Appeler
  </a>
);

export default CallFab;
